/* global rp$, document, window */
import get from 'lodash/get';
import paypalSmartButtons from '../../../js/components/paypal-smart-buttons';
import 'bootstrap';

var THE_SCRIPT = function() {
	const $onReady = require("public/js/lib/on-ready");
	const { makeDivSticky } = require('public/js/lib/sticky-div');
	const {
		getInventoryMessage,
		getShippingMessage,
		getShippingMessageTitle,
		getShippingEstimateMessage,
		getPickupMessage,
		getInventoryMessageCustomerId,
		getInventoryMessageWarehouseId,
		handleZipChangeEvent
	} = require('public/js/lib/product-message-utils');

	(function ProductInventoryMessagingModule() {
		function HandleInventoryMessageResponse({
			$inventoryMessageContentEle,
			$shippingMessageContentEle,
			$shippingEstimateMessageContentEle,
			$shippingEstimateMessageHelpTextEle,
			$shippingEstimatePostalCodeEle,
			$shippingMessageSectionTitleEle,
			$shippingMessageSectionEle,
			$pickupMessageContentEle,
			$pickupMessageSectionEle,
			$addToCartBtn,
			$inventoryWrap,
            $shippingIcon,
            $inventoryStockIcon
		}) {
			return function(evt, response) {
				// Unset `Add To Cart` button's data attribute (data-inventory-message)
				// when no `inventoryMessage`
				const responseInventoryMessage = getInventoryMessage(response);
				const responseShippingMessage = getShippingMessage(response);
				const responseShippingMessageTitle = getShippingMessageTitle(response);
				const responseShippingEstimateMessage = getShippingEstimateMessage(response);
				const responseInventoryMessageCustomerId = getInventoryMessageCustomerId(response);
				const responseInventoryMessageWarehouseId = getInventoryMessageWarehouseId(response);

				const responsePickupMessage = getPickupMessage(response);
				const responseInventoryType = response.inventoryMessageType ? response.inventoryMessageType : '';
				$inventoryMessageContentEle.html(responseInventoryMessage);
				$shippingMessageContentEle.html(responseShippingMessage);
				$shippingMessageSectionTitleEle.html(responseShippingMessageTitle);
				$shippingEstimateMessageContentEle.html(responseShippingEstimateMessage);
				$pickupMessageContentEle.html(responsePickupMessage);

				$addToCartBtn.attr(
					"data-inventory-message",
					responseInventoryMessage
				);
				$addToCartBtn.attr(
					"data-shipping-message",
					responseShippingMessage
				);

				$inventoryWrap.removeClass('inventory-out-of-stock');
				if (responseInventoryType === 'OutOfStockMessagingOnly') {
					$inventoryWrap.addClass('inventory-out-of-stock');
				}

				$inventoryWrap.attr("hidden", !$inventoryWrap.parent().hasClass('fitment-redesign') && responseInventoryMessage === '');
				$shippingMessageContentEle.attr("hidden", responseShippingMessage === '');
				$shippingMessageSectionEle.attr("hidden", responseShippingMessage === '' && responseShippingEstimateMessage === '');
				$shippingEstimateMessageContentEle.attr("hidden", responseShippingEstimateMessage === '');
				$pickupMessageSectionEle.attr("hidden", responsePickupMessage === '');
				$shippingEstimateMessageHelpTextEle.attr("hidden", responseShippingEstimateMessage === '');

                $shippingIcon.attr("hidden", responseShippingMessage === '');
                $inventoryStockIcon.attr("hidden", responseInventoryMessage === '');

				if (responseShippingEstimateMessage !== '') {
					$shippingEstimateMessageContentEle.attr(
						"data-inventory-warehouse-id",
						responseInventoryMessageWarehouseId
					);

					$shippingEstimateMessageContentEle.attr(
						"data-inventory-warehouse-customer-id",
						responseInventoryMessageCustomerId
					);
				}

				handleZipChangeEvent();

				// Update the tracking value to accurately depict what's on the page
				if (responseInventoryType && window.tracking && (typeof window.tracking.dimensions === 'object')) {
					window.tracking.dimensions.stockLevelMessaging = responseInventoryType;
				}
			};
		}

		function HandleDealerSelect(evt) {
			evt.preventDefault();
			const dealerHash = rp$(this).data("fulfillment-hash");
			if(!dealerHash ) {
				return;
			}

			$ajax({
				method: "POST",
				dataType: "json",
				url: "/ajax/dealers",
				data: {
					dealerHash
				},
				success: (response, status /*, xhr*/) => {
					if (status === "success") {
						rp_app.location.reload();
					}
				}
			});
		}

		function HandleViewMoreDealers(evt) {
			evt.preventDefault();

			window.rp_app.request({
				type: 'GET',
				url: '/ajax/cart',
				dataType: 'json',
				contentType: 'application/json',
				success: HandleViewMoreDealersRedirect,
			});
		}

		function HandleViewMoreDealersRedirect(cart) {
			const cartHasItems = !!get(cart, 'itemsCount');
			if (cartHasItems) {
				const $dealerSelectionWarningModal = rp$(".dealer-selection-warning-modal");
				if ($dealerSelectionWarningModal) {
					$dealerSelectionWarningModal.modal();
				}
			} else {
				ClearSelectedDealer();
			}
		}

		function ClearSelectedDealer() {
			$ajax({
				method: "GET",
				dataType: "json",
				url: "/ajax/dealers/clear",
				success: (response, status /*, xhr*/) => {
					if (status === "success") {
						rp_app.location.reload();
					}
				}
			});
		}



		$onReady({
			rp$,
			window,
			label: "product_purchase",
			fn: function() {
				makeDivSticky('.product-purchase-module');
				const $inventoryMessageContentEle = rp$("#rp_inventory_message");
				const $shippingMessageContentEle = rp$("#rp_shipping_message");
				const $shippingEstimateMessageContentEle = rp$("#rp_shipping_estimate_message");
				const $shippingMessageSectionTitleEle = rp$(".shipping-message-title");
				const $shippingMessageSectionEle = rp$(".shipping-message-section");
				const $shippingEstimateMessageHelpTextEle = rp$(".shipping-estimate-message-helptext");
				const $shippingEstimatePostalCodeEle = rp$(".shipping-estimate-postal-code");
				const $pickupMessageContentEle = rp$("#rp_pickup_message");
				const $pickupMessageSectionEle = rp$(".pickup-message-section");
				const $addToCartBtn = rp$(".product-purchase button.add-to-cart");
				const $inventoryWrap = rp$("#inventory_wrap");
                const $shippingIcon = rp$(".shipping-icon");
                const $inventoryStockIcon = rp$(".badge-instock");
				if ($inventoryMessageContentEle && $inventoryMessageContentEle.length > 0 && $addToCartBtn) {
					const eventHandler = HandleInventoryMessageResponse({
						$inventoryMessageContentEle,
						$shippingMessageContentEle,
						$shippingEstimateMessageContentEle,
						$shippingEstimateMessageHelpTextEle,
						$shippingEstimatePostalCodeEle,
						$shippingMessageSectionTitleEle,
						$shippingMessageSectionEle,
						$pickupMessageContentEle,
						$pickupMessageSectionEle,
						$addToCartBtn,
						$inventoryWrap,
                        $shippingIcon,
                        $inventoryStockIcon
					});

					/* Handle inventory message Response
					.*-----------------------------------------*/
					// Due to plugin, all things that depend on document and window are up for causing bugs. Lets clean up before we start
					rp$(document).off(
						"productGetInventoryMessage:response",
						eventHandler
					);
					rp$(document).on("productGetInventoryMessage:response", eventHandler);
				}

				const $dealerSelect = rp$(".offer-dealer-list .dealer-select-button");
				if ($dealerSelect && $dealerSelect.length > 0) {
					$dealerSelect.each(function() {
						rp$(this).on("click", HandleDealerSelect);
					})
				}

				const $viewOffersLink = rp$(".purchase-box .view-offers-link");
				if ($viewOffersLink) {
					$viewOffersLink.on("click", HandleViewMoreDealers);
				}

				const $viewOffersButton = rp$(".view-more-dealer-btn");
				if ($viewOffersButton) {
					$viewOffersButton.on("click", HandleViewMoreDealers);
				}

				// viewOffersLink -> dealerSelectionWarningModal
				const $dealerSelectionWarningModal = rp$(".dealer-selection-warning-modal");
				const $warningModalContinueButton = rp$(".continue-button", $dealerSelectionWarningModal);
				$warningModalContinueButton.on("click", ClearSelectedDealer);

				// adding paypal payment message

				let sale_price = '';
				try {
					sale_price = rp$('.product-purchase-module').data('sale-price');
				} catch (e) {/* do nothing if sale price is empty or not having value */}

				const paymentsMessageContainerClass = '.pp-message';
				const paymentsMessageData = {
					elemOrSelector: paymentsMessageContainerClass,
					amount: sale_price,
					placement: 'product',
				}
				paypalSmartButtons.initPaypalMessage(paymentsMessageData);
			}
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}

export default THE_SCRIPT;
